module.exports = __webpack_public_path__ + "img/typingtest.dbcb4ee2.svg";